import axios from 'axios'
const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}`

/**
 * 혈당 스캔 식단 기준 정보 생성
 * @param {*} param mealCategeryId, mealName
 * @param {*} formData mealImage
 * @returns
 */
const upsertMeal = async (param, formData) => {
  const res = await axios.post(
    `${baseUrl}/v2/admin/meal/register?mealCategoryId=${param.mealCategoryId}&mealName=${param.mealName}`,
    formData,
  )
  return res
}

/**
 * 음식 요청 목록 조회 및 상태 검색
 */
const getMealRequestList = async (params) => {
  const { page = 0, size = 10, status } = params

  let queryParams = `page=${page}&size=${size}`
  if (status) {
    queryParams += `&status=${status}`
  }

  const res = await axios.get(
    `${baseUrl}/v2/admin/meals/requests?${queryParams}`,
  )
  return res
}

/**
 * 음식 요청 목록 승인
 * @param {*} requestId
 * @param {*} param mealCategoryId, mealName
 */
const approveMealRequest = async (requestId, param) => {
  const res = await axios.post(
    `${baseUrl}/v2/admin/meals/requests/${requestId}/approve`,
    param,
  )
  return res
}

/**
 * 음식 요청 목록 반려
 * @param {*} requestId
 * @param {*} param { reason, rejectAdminReason }
 */
const rejectMealRequest = async (requestId, param) => {
  const res = await axios.post(
    `${baseUrl}/v2/admin/meals/requests/${requestId}/reject`,
    param,
  )
  return res
}

/**
 * 음식 전체 목록 및 검색
 * @param {*} searchParams mealName, mealCategoryId
 */
const getMealList = async (params) => {
  const { page = 0, size = 10, ...searchParams } = params
  const res = await axios.post(
    `${baseUrl}/v2/admin/meals?page=${page}&size=${size}`,
    searchParams,
  )
  return res
}

/**
 * 음식 단건 조회
 */
const getMealDetail = async (mealId) => {
  const res = await axios.get(`${baseUrl}/v2/admin/meals/${mealId}`)
  return res
}

/**
 * 음식 수정
 * @param {*} mealId
 * @param {*} param mealCategoryId, mealName
 * @param {*} file 이미지 파일 (선택사항)
 */
const updateMeal = async (formData) => {
  const res = await axios.post(`${baseUrl}/v2/admin/meal/update`, formData)
  return res
}

const mealApi = {
  upsertMeal,
  getMealRequestList,
  approveMealRequest,
  rejectMealRequest,
  getMealList,
  getMealDetail,
  updateMeal,
}

export default mealApi
